import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { getAccessPointGeneral, getAccessPointConfiguration, } from "@reducers/access-points/thunk/access-point-thunk";
import { setSelectedAccessPoint } from "@reducers/access-points/slice/access-point-slice";
export const useAPData = (apId) => {
    const dispatch = useAppDispatch();
    const { selectedAccessPoint: ap, singleLoading: loading, singleError: error, } = useAppSelector((state) => state.accessPoint);
    const isEdit = Boolean(apId);
    const apExists = isEdit ? ap !== null : true;
    useEffect(() => {
        if (apId) {
            // Fetch access point general settings
            dispatch(getAccessPointGeneral(apId));
        }
        else {
            // New AP - clear selected
            dispatch(setSelectedAccessPoint(null));
        }
        // Cleanup on unmount
        return () => {
            dispatch(setSelectedAccessPoint(null));
        };
    }, [apId, dispatch]);
    // Function to reload configuration settings
    const reloadConfiguration = () => {
        if (apId) {
            dispatch(getAccessPointConfiguration(apId));
        }
    };
    return {
        ap,
        loading,
        error,
        apExists,
        isEdit,
        reloadConfiguration,
    };
};
